<template>
  <div>
    大屏
    <!-- 在router中直接用路由守卫跳转了 -->
  </div>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>

</style>